import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, Dialog, IconButton, Typography } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import theme from 'theme';
import { CssTextField } from 'views/Common/CssTextField';

const PREFIX = 'AddFolderModal';

const classes = {
    root: `${PREFIX}-root`,
    root2: `${PREFIX}-root2`,
    root3: `${PREFIX}-root3`,
    closeButton: `${PREFIX}-closeButton`,
    appBar: `${PREFIX}-appBar`,
    appBar2: `${PREFIX}-appBar2`,
    title: `${PREFIX}-title`
};

const StyledMuiDialogTitle = styled(MuiDialogTitle)((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.appBar2}`]: {
        position: 'relative',
    },

    [`& .${classes.title}`]: {
        marginLeft: theme.spacing(2),
        flex: 1,
    }
}));

const AddFolderModal = (props: any) => {
	const { isShow, handleClose, isRenameFolder, heading, inputLabel } = props;
	const [folderName, setFolderName] = useState('');
	const handleOnChange = (e: any) => {
		setFolderName(e.target.value);
	};

	const submitForm = (e: any) => {
		e.preventDefault();
		props.createFolder(folderName);
	};


	return (
        <Dialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={isShow}>
			<AppBar className={classes.appBar} style={{position:'unset', backgroundColor:'#042630'}}>
				<Toolbar>
					<IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        size="large">
						<CloseIcon />
					</IconButton>
					<Typography variant="h6" className={classes.title}>
						{heading}
					</Typography>
				</Toolbar>
			</AppBar>
			<StyledMuiDialogContent
                dividers
                classes={{
                    root: classes.root
                }}>
				<CssTextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					autoComplete="off"
					label={inputLabel}
					name="folderName"
					autoFocus
					value={folderName}
					onChange={handleOnChange}
				/>

				<Button onClick={submitForm} disabled={folderName === ''} style={{color:'#042630'}}>
					{isRenameFolder ? 'Rename' : 'Create'}
				</Button>
			</StyledMuiDialogContent>
		</Dialog>
    );
};

export default AddFolderModal;
export interface DialogTitleProps  {
	id: string;
	children: React.ReactNode;
	onClose: () => void;
}

export const DialogTitle = ((props: DialogTitleProps) => {
	const { children,  onClose, ...other } = props;
	return (
        <StyledMuiDialogTitle className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                    size="large">
					<CloseIcon />
				</IconButton>
			) : null}
		</StyledMuiDialogTitle>
    );
});

export const StyledMuiDialogContent = styled(MuiDialogContent)(({theme:Theme}) => (
	{
	  [`&.${classes.root}`]: {
		padding: theme.spacing(2),
	  },
	  [`& .${classes.root2}`]: {
		margin: 0,
		padding: theme.spacing(1),
	  }
	}
  ))

  export const StyledMuiDialogActions = styled(MuiDialogActions) (({theme:Theme}) => ({
	[`& .${classes.root2}`]: {
		  margin: 0,
		  padding: theme.spacing(1),
	  }
  }))
